import { fmtCurrency } from "../../../../utils/functions";

export function buildPackFeatures(pack) {
  const f = [];
  if (pack?.aiCandidateMatching) f.push("AI-powered candidate matching");
  if (pack?.top5CandidateShortlist) f.push("Top candidates shortlist");
  if (pack?.creditsNeverExpire) f.push("Credits never expire");
  if (pack?.packsStack) f.push("Packs stack — buy more any time");
  if (pack?.emailSupport) f.push("Email support");
  if (pack?.teamCollaboration) f.push("Team collaboration");
  if (pack?.advancedAnalytics) f.push("Advanced analytics");
  if (pack?.apiAccess) f.push("API access");
  return f;
}

export function mapTopUpPacks(apiTopUpPlans, { currency } = {}) {
  const isNGN = currency === "NGN";

  const sorted = [...apiTopUpPlans]?.sort((a, b) => a?.priceNGN - b?.priceNGN);

  return sorted?.map((pack, i) => {
    const displayPrice = isNGN ? pack?.priceNGN : pack?.priceUSD;
    const isFeatured = i === 1;
    return {
      id: pack?._id,
      planKind: "topup",
      featured: "",
      topBadge: "",
      tierLabelColor: "#10b981",
      inlineTag: isFeatured ? "POPULAR" : "",
      tierLabel: pack?.name?.toUpperCase(),
      name: pack?.name,
      priceCurrency: isNGN ? "₦" : "$",
      currency: pack?.currency,
      priceValue: displayPrice?.toLocaleString("en-US"),
      price: displayPrice,
      priceNGN: pack?.priceNGN,
      priceUSD: pack?.priceUSD,
      pricePerCredit: pack?.creditUnit,
      tagline: { type: "chip", text: `${pack?.creditUnit} credits · one-time` },
      features: buildPackFeatures(pack),
      cta: {
        label: `Buy ${pack?.name}`,
        variant: "default",
        toastMessage: `Purchasing ${pack?.name} — ${fmtCurrency(displayPrice, currency)}, ${pack?.creditUnit} credits added instantly…`,
      },
    };
  });
}
